import React, { useEffect, useRef, useState } from "react";
import Loader from "../../../../components/loader/loader";
import Snackbar from "../../../../components/snackbar/snackbar";
import {
  create_company_request,
  user_company_domain_list,
  new_company_update_request,
  new_company_kerala_update_request,
} from "../../user.api";

import BasicDetails from "./manage/form";
import View from "./manage/viewDetails";
import "./style.css";

export default function NewCompanyRequest(props) {
  const [activeStep, setActiveStep] = useState(0);
  const [defaultkey, setdefaultkey] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [basicData, setBasicData] = useState({
    mobile_number: props.phone,
  });
  const myRef = useRef(null);
  const [domainData, setDomain] = useState([]);
  const [addCount, setCount] = useState(1);

  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const getDomainTypes = () => {
    setIsActive(true);
    user_company_domain_list().then((res) => {
      setDomain(res.data);
      setCount(addCount + 1);
      setIsActive(false);
    });
  };
  const action = (id, data, key) => {
    myRef.current.scrollIntoView();
    if (id === 0) {
      let dom = [];
      domainData.forEach((item) => {
        if (item.checked)
          dom.push({ domain_name: item.domain_name, id: item.id });
      });

      setBasicData({ ...data, domain_types: dom });
      setActiveStep(1);
      //
    } else if (id === 2) {
      setdefaultkey(key);
      setActiveStep(0);

      // setBasicData({ ...data });
    } else if (id === 3) {
      // setBasicData({ ...data });
      handleSubmit();
    }
  };
  const handleSubmit = () => {
    setIsActive(true);

    let areatype = [];
    if (basicData.area_management) {
      basicData?.area_management?.forEach((item, index) => {
        if (item.location_id) {
          areatype[index] = item;
        }
      });
    }
    const form = new FormData();
    console.log(basicData.product_profiles);

    const appendIfValue = (key, value) => {
      if (value !== null && value !== undefined && value !== "" && value !== "null" && value !== "undefined") {
        form.append(key, value);
      }
    };

    appendIfValue("company_name", basicData.company_name);
    appendIfValue("phone_number", basicData.mobile_number);
    appendIfValue("company_type", "kerala");
    appendIfValue("person_name", basicData.person_name);
    appendIfValue("person_designation", basicData.person_designation);
    appendIfValue("address", basicData.address);
    appendIfValue("email", basicData.email);
    appendIfValue("alternate_email", basicData.alternate_email);
    appendIfValue("logo", basicData.logo);

    if (
      basicData.country_code &&
      basicData.country_code !== "" &&
      basicData.alternate_phone &&
      basicData.alternate_phone !== ""
    ) {
      appendIfValue("country_code", basicData.country_code);
    }
    appendIfValue("alternate_phone", basicData.alternate_phone);
    appendIfValue(
      "abstract_project_proposal",
      basicData.abstract_project_proposal
    );
    appendIfValue("upload_proposal", basicData.upload_proposal);
    appendIfValue("registration_certificate", basicData.registration_certificate);
    // form.append("capital_investment", basicData.capital_investment ?? null);
    appendIfValue("ex_man_power", basicData.ex_man_power);
    appendIfValue("site_link", basicData.site_link);
    appendIfValue("company_status", "existing_company");

    // Append financial records as array
    (basicData.financial_records || []).forEach((record, index) => {
      appendIfValue(`financial_records[${index}][financial_year]`, record.financial_year);
      appendIfValue(`financial_records[${index}][fy_turnover]`, record.fy_turnover);
      appendIfValue(`financial_records[${index}][remarks]`, record.remarks);
      appendIfValue(`financial_records[${index}][capital_investment]`, record.capital_investment);
      appendIfValue(`financial_records[${index}][dir_employ_male]`, record.dir_employ_male);
      appendIfValue(`financial_records[${index}][dir_employ_female]`, record.dir_employ_female);
      appendIfValue(`financial_records[${index}][dir_employ_others]`, record.dir_employ_others);
      appendIfValue(`financial_records[${index}][dir_employ_sc_st]`, record.dir_employ_sc_st);
      appendIfValue(`financial_records[${index}][dir_employ_pwd]`, record.dir_employ_pwd);
    });
    appendIfValue("cin_number", basicData?.cin_number ?? "--");
    // form.append("product_profiles", basicData.product_profiles ?? null);

    appendIfValue("achievements", basicData.achievements);
    if (basicData.fe_component) {
      appendIfValue("fe_component", basicData.fe_component);
    }
    if (basicData.certification === "Other") {
      if (basicData.otherCertification && String(basicData.otherCertification).trim() !== "") {
        appendIfValue("certification", basicData.otherCertification);
      }
    } else if (basicData.certification && String(basicData.certification).trim() !== "") {
      appendIfValue("certification", basicData.certification);
    }


    appendIfValue("any_other_flag", basicData.any_other_flag == true ? "1" : "0");
    appendIfValue(
      "any_other_domain",
      basicData.any_other_flag == true ? basicData.any_other_domain : ""
    );
    appendIfValue("file_name", basicData.file_name);
    appendIfValue("registration_certificate_name", basicData.registration_certificate_name);
    if (basicData.id) appendIfValue("application_id", basicData.id);
    basicData.product_profiles.forEach((item, index) => {
      appendIfValue(
        `product_profiles[${index}][product_name]`,
        item.product_name
      );
      appendIfValue(
        `product_profiles[${index}][product_desc]`,
        item.product_desc
      );
    });

    basicData.domain_types.forEach((item, index) => {
      appendIfValue(`domain_types[${index}][domain_name]`, item.domain_name);
      appendIfValue(`domain_types[${index}][id]`, item.id);
    });

    const isUserLoggedIn = props.state?.isUserAuthenticated || false;
    const requestApi = isUserLoggedIn ? new_company_kerala_update_request : create_company_request;

    requestApi(form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        let errMsg = "An error occurred";
        if (error.response && error.response.data) {
          if (error.response.data.message) {
            errMsg = error.response.data.message;
          }
          if (error.response.data.error) {
            const errors = error.response.data.error;
            if (typeof errors === "object") {
              const firstKey = Object.keys(errors)[0];
              if (firstKey && Array.isArray(errors[firstKey]) && errors[firstKey][0]) {
                errMsg = errors[firstKey][0];
              }
            } else if (typeof errors === "string") {
              errMsg = errors;
            }
          } else if (error.response.data.errors) {
            const errors = error.response.data.errors;
            if (typeof errors === "object") {
              const firstKey = Object.keys(errors)[0];
              if (firstKey && Array.isArray(errors[firstKey]) && errors[firstKey][0]) {
                errMsg = errors[firstKey][0];
              }
            }
          }
        }
        setSnackMessage(errMsg);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  useEffect(() => {
    if (domainData.length === 0) {
      getDomainTypes();
    }
    // handleChangedata("3");
  }, []);
  const snackbarClose = (flag) => {
    const isError = isSnackError;
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag && !isError) {
      if (props.state?.isUserAuthenticated) {
        props.history.push("/dashboard");
      } else {
        setActiveStep(0);
        setBasicData({});

        setDomain([]);
        props.logout();
      }
    }
  };
  return (
    <div className="page-bg" ref={myRef}>
      <div>
        <Loader open={isActive} />
        <div className="dash-banner ">
          <div className="tit-txt">
            Affiliate an Existing Aerospace Unit in Kerala with KSPACE
          </div>
        </div>
      </div>
      <div className=" my-5 ">
        <div className="container  d-flex justify-content-center">
          {/* <div className="itemc"> */}
          {/* <div className="fomy form-inner-section"> */}
          {activeStep === 0 && (
            <BasicDetails
              {...props}
              data={basicData}
              action={action}
              formData={basicData}
              setDomain={setDomain}
              domainData={domainData}
            />
          )}

          {activeStep === 1 && (
            <View {...props} basicData={basicData} action={action} />
          )}
        </div>
        <Snackbar
          message={snackMessage}
          error={isSnackError}
          open={snackOpen}
          close={snackbarClose}
        />
        {/* </div> */}
        {/* </div> */}
      </div>
    </div>
  );
}
